<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>add</v-icon> Crear solicitud con cargo a vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form
        @submit.prevent="adicionarDetalle()"
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <v-card-text class="py-0">
          <v-container grid-list-md class="py-0" style="min-width: 100%;">
            <v-layout row wrap>
              <v-flex xs12>
                <v-card
                  v-if="dato && dato.sw_programacion"
                  color="indigo"
                  class="px-3 white--text text-xs-center text-md-left"
                >
                  <v-layout row wrap>
                    <v-flex xs12
                      ><span class="caption">TOTAL DÍAS RESERVA RESTANTES</span
                      ><br />
                      <span class="display-1">
                        {{
                          dato.dias_reserva - dato.total_dias_creados_reserva
                        }}
                      </span>
                    </v-flex>
                    <!-- <v-flex xs12 md6
                      ><span class="caption">DÍAS RESERVA SOLICITADOS</span
                      ><br />
                      <span class="display-1">
                        {{ dato.total_dias_creados_reserva }}
                      </span>
                    </v-flex> -->
                  </v-layout>
                </v-card>
                <v-card v-else color="blue" class="px-3 white--text ">
                  <v-flex xs12 md6>
                    <span class="caption"
                      >TOTAL DÍAS NO PROGRAMADOS RESTANTES</span
                    ><br />
                    <span class="display-1">{{
                      dato.saldo_no_programadas
                    }}</span>
                  </v-flex>
                  <!-- <v-flex xs12 md6                  >
                  <span class="caption">DÍAS NO PROGRAMADOS SOLICITADOS</span><br />
                  <span class="display-1">
                    {{ dato.total_dias_creados_reserva }}
                  </span>
                </v-flex> -->
                </v-card>
              </v-flex>

              <!-- <p class="titulo">Total días de vacación :</p>
              <p class="texto">{{ total_dias_no_programados }} días</p>
              <v-spacer></v-spacer>
              <p class="titulo">Total días solicitados :</p> -->
              <!-- <p class="texto">
                {{ total_dias_solicitadas ? total_dias_solicitadas : "0" }} días
              </p> 
            <p class="titulo">Total días no programados:</p>
              <p class="texto">{{ this.dato.saldo_no_programadas }} días</p>
            -->
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha desde"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                  outline
                />
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha hasta"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                  outline
                />
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-if="
                    form.fecha_desde &&
                      form.fecha_hasta &&
                      (form.radio_data == 1 ||
                        form.radio_data == 2 ||
                        form.radio_data == 0)
                  "
                  class="text-field-reducido-border"
                  v-model="total_dias"
                  label="Días"
                  disabled
                  outline
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex shrink>
                <v-radio-group
                  class="text-field-reducido"
                  @change="calculaDiferenciaDias()"
                  v-model="form.radio_data"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs4>
                    <v-radio label="Todo el día" :value="0"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12>
                <v-spacer></v-spacer>
                <v-btn color="success" block type="submit" :disabled="!valid">
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-text v-if="permiso_detalles.length > 0">
          <v-container grid-list-md class="py-0" style="min-width: 100%;">
            <v-layout wrap>
              <v-flex>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :items="permiso_detalles"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                    </td>
                    <td class="text-xs-center">
                      {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                    </td>
                    <td class="text-xs-center">
                      {{
                        $moment(props.item.hora_desde, "HH:mm").format("HH:mm")
                      }}
                    </td>
                    <td class="text-xs-center">
                      {{
                        $moment(props.item.hora_hasta, "HH:mm").format("HH:mm")
                      }}
                    </td>
                    <td class="text-xs-center">
                      <v-chip
                        color="success"
                        text-color="white"
                        v-if="props.item.tipo == 0"
                        >Todo el dia</v-chip
                      >
                      <v-chip
                        color="blue"
                        text-color="white"
                        v-if="props.item.tipo == 1"
                        >Solo mañana</v-chip
                      >
                      <v-chip
                        color="orange"
                        text-color="white"
                        v-if="props.item.tipo == 2"
                        >Solo tarde</v-chip
                      >
                    </td>
                    <td class="text-xs-center">
                      <v-btn
                        color="error"
                        icon
                        title="Eliminar"
                        @click.prevent="eliminarDetalle(props.item.id)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                  <template v-slot:footer>
                    <td colspan="4" class="footer-table">
                      <strong>{{ `Total dias` }}</strong>
                    </td>
                    <td class="text-xs-center title">
                      <strong>{{ total_dias_solicitadas }}</strong>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn @click.native="close()" color="error">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save()"
            :disabled="this.permiso_detalles.length <= 0"
          >
            <v-icon>save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogCrearPermisoCargoVacacion", async dato => {
      this.dato = dato;
      await this.verEstadoVacacion();
      this.dialog = true;
    });

    this.getPersonaId();
    this.getRuta();
  },
  data() {
    return {
      form: {},
      total_dias: 0,
      id_permi: "",
      fecha_desde: "",
      fecha_hasta: "",
      radio_data: "",
      dialog: false,
      edit: true,
      dias_saldo_para_papeletas: 0,
      permiso: {
        id_tipo_permiso: null,
        motivo: "",
        permi_fecha_hasta: "",
        permi_fecha_desde: ""
      },
      permisos: [],
      tipo_permisos: [],
      permiso_compensacion: [],
      aux: {},
      permiso_detalle: {},
      dias_programados_por_gestion: 0,
      valid: false,
      loading: false,
      headers: [
        {
          text: "Fecha salida",
          align: "center",
          sortable: false
        },
        {
          text: "Fecha hasta",
          align: "center",
          sortable: false
        },
        {
          text: "Hora desde",
          align: "center",
          sortable: false
        },
        {
          text: "Hora hasta",
          align: "center",
          sortable: false
        },
        {
          text: "Tiempo",
          align: "center",
          sortable: false
        },

        {
          text: "Acción",
          align: "center",
          sortable: false
        }
      ],
      permiso_detalles: [],
      count_id: 0,
      // variables nueva funcionalidad
      dato: {},
      tiempo_vacaciones: 0,
      v_fecha_desde: [],
      v_fecha_hasta: [],
      v_hora_desde: [],
      v_hora_hasta: [],
      total_dias_solicitadas: 0,
      total_dias_no_programados: 0
    };
  },
  methods: {
    //obtener el saldo de vacaciones
    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      let fecha = new Date();
      let gestion = fecha.getFullYear();
      try {
        let res = await this.$service.graphql({
          query: `
						
						query{
                  vEstadoVacacions(id_persona: ${parseInt(
                    this.getPersonaId()
                  )},gestion_hasta:"${gestion}"){
                    rows{
                       nombre
                      dias_saldo
                      dias_asignados
                      dias_utilizados
                      dias_programados
                      dias_cta_vacacion
                      id
                      id_estado
                      id_persona
                      nombre
                      ingreso
                      gestion_desde
                      gestion_hasta
                      cas
                      estado
                      dias_a_programar
                      total_dias_saldo
                      saldo_a_programar
                    }
                  }
                } 
					`
        });

        if (res.vEstadoVacacions.rows) {
          let estado_vacacion = res.vEstadoVacacions.rows;

          this.total_dias_no_programados = estado_vacacion[0].total_dias_saldo
            ? estado_vacacion[0].total_dias_saldo
            : 0;
          this.dias_programados_por_gestion = estado_vacacion[0]
            .dias_programados
            ? estado_vacacion[0].dias_programados
            : 0;
          let dias_totales2 =
            parseFloat(this.total_dias_no_programados) -
            parseFloat(this.dias_programados_por_gestion);
          this.dias_saldo_para_papeletas =
            parseFloat(dias_totales2) - parseFloat(this.dato.total_vacaciones);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiferenciaDias() {
      try {
        let res;

        if (
          this.form.fecha_desde &&
          this.form.fecha_hasta &&
          (this.form.radio_data == 1 ||
            this.form.radio_data == 2 ||
            this.form.radio_data == 0)
        ) {
          res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${this.form.fecha_desde}','${this.form.fecha_hasta}',${this.getPersonaId()})"){
								respuesta
							}
							}
						`
          });
          let res2;
          if (this.form.radio_data == 1 || this.form.radio_data == 2) {
            res2 =
              parseInt(
                res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona
              ) / 2;
          }
          if (this.form.radio_data == 0) {
            res2 =
              res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;
          }
          this.total_dias = res2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Obtiene el horario de una persona
    async obtenerHorarioPersona(id_persona, id_radio_data) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select control.fn_rango_horario_por_persona_solo_horarios(${parseInt(
                id_persona
              )},${parseInt(id_radio_data)},'${this.form.fecha_desde}')"){
                respuesta
              }
            }
          `
        });
        if (
          respuesta.runQuery.respuesta[0]
            .fn_rango_horario_por_persona_solo_horarios != null
        ) {
          respuesta = respuesta.runQuery.respuesta[0].fn_rango_horario_por_persona_solo_horarios.split(
            "|"
          );
          if (respuesta[0] != "0") {
            return [respuesta[0], respuesta[1]];
          } else {
            return "No";
          }
        } else {
          this.$message.warning(
            "Sin horario asignado para la fecha del permiso"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verificaCreacionPermiso(
      fecha_desde,
      fecha_hasta,
      radio_data,
      hora_desde,
      hora_hasta,
      list_permiso_detalles
    ) {
      try {
        let respuesta;
        let rpta = "1";
        let vector_fecha_desde;
        let vector_fecha_hasta;
        let vector_hora_desde;
        let vector_hora_hasta;
        let bandera_vector;
        vector_fecha_desde = "{" + this.v_fecha_desde.join(",") + "}";
        vector_fecha_hasta = "{" + this.v_fecha_hasta.join(",") + "}";
        vector_hora_desde = "{" + this.v_hora_desde.join(",") + "}";
        vector_hora_hasta = "{" + this.v_hora_hasta.join(",") + "}";
        if (list_permiso_detalles.length < 1) {
          bandera_vector = 0;
        } else {
          bandera_vector = 1;
        }

        respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_valida_fechas_vacacion(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}','${vector_fecha_desde}','${vector_fecha_hasta}','${vector_hora_desde}','${vector_hora_hasta}',${bandera_vector},null)"){
                  respuesta
                  }
                }
              `
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_valida_fechas_vacacion;
        rpta = respuesta.split("|");
        if (rpta[0] == "3") {
          return rpta[1];
        } else if (rpta[0] == "0") {
          return "Registro exitoso|" + rpta[1];
        } else if (rpta[0] == "1") {
          return (
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            rpta[1].replace(/#/g, "<br>")
          );
        } else {
          let resp = rpta[1].split(",");
          return "Usted registro un detalle en fechas:" + resp[0] + " al ";
        }
      } catch (error) {
        console.log(error);
      }
    },
    validarFechasFinales() {
      //validando fechas:
      let bandera_fechas = true;

      if (this.form.fecha_desde && this.form.fecha_hasta) {
        if (this.form.fecha_desde.length > 10) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        if (this.form.fecha_hasta.length > 10) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        let año1 = parseInt(this.form.fecha_desde.substring(0, 4));
        let año2 = parseInt(this.form.fecha_hasta.substring(0, 4));

        if (año1 > 2022) {
          if (año1 > 2999) {
            this.$message.info("Año desde no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
        if (año2 > 2022) {
          if (año2 > 2999) {
            this.$message.info("Año desde no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
        if (año1 < 2023) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        if (año2 < 2023) {
          this.$message.info("Año hasta no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
      }

      return bandera_fechas;
    },
    async adicionarDetalle() {
      if (this.$refs.form.validate()) {
        try {
          if (this.validarFechasFinales() == false) {
            return;
          }

          let horario = await this.obtenerHorarioPersona(
            this.getPersonaId(),
            this.form.radio_data
          );
          if (horario != "No") {
            let verifica_creacion_vacacion = await this.verificaCreacionPermiso(
              this.form.fecha_desde,
              this.form.fecha_hasta,
              this.form.radio_data,
              horario[0],
              horario[1],
              this.permiso_detalles
            );
            let verifica_creacion_vacacion_2 = verifica_creacion_vacacion.split(
              "|"
            );
            if (verifica_creacion_vacacion_2[0] == "Registro exitoso") {
              //sumar los dias y verificar que no se excedan los dias de su vacacion:
              this.total_dias_solicitadas += parseFloat(
                verifica_creacion_vacacion_2[1]
              );
              if (!this.total_dias_solicitadas) {
                this.total_dias_solicitadas = 0;
              }
              // Validamos dias no programados o de reserva
              if (
                (!this.dato.sw_programacion && this.total_dias_solicitadas <= this.dato.saldo_no_programadas )||
                (this.dato.sw_programacion &&
                  this.total_dias_solicitadas <=
                    this.dato.dias_reserva -
                      this.dato.total_dias_creados_reserva)
              ) {
                //almacenar los datos ya verificados
                const temp = {
                  fecha_desde: this.form.fecha_desde,
                  fecha_hasta: this.form.fecha_hasta,
                  tipo: this.form.radio_data,
                  hora_desde: horario[0],
                  hora_hasta: horario[1],
                  id: this.count_id++,
                  total_dias: verifica_creacion_vacacion_2[1]
                };
                this.permiso_detalles.push(temp);
                this.v_fecha_desde.push(this.form.fecha_desde);
                this.v_fecha_hasta.push(this.form.fecha_hasta);
                this.v_hora_desde.push(horario[0]);
                this.v_hora_hasta.push(horario[1]);
                this.form = {};
                this.$message.success("Detalle Agregado.");
              } else {
                this.total_dias_solicitadas -= parseFloat(
                  verifica_creacion_vacacion_2[1]
                );
                this.$message.info(
                  "Excede el total de dias de su saldo de vacacion"
                );
              }
            } else {
              this.$message.info(verifica_creacion_vacacion);
            }
          } else {
            this.$message.info("Usted no tiene un horario laboral asignado");
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    eliminarDetalle(id) {
      let tempList = this.permiso_detalles;
      for (let i = 0; i <= tempList.length; i++) {
        if (tempList[i].id === id) {
          this.total_dias_solicitadas -= parseFloat(tempList[i].total_dias);
          tempList.splice(i, 1);
          this.v_fecha_desde.splice(i, 1);
          this.v_fecha_hasta.splice(i, 1);
          this.v_hora_desde.splice(i, 1);
          this.v_hora_hasta.splice(i, 1);
          break;
        }
      }
      this.permiso_detalles = tempList;
      this.valid = true;
      this.$message.success("Detalle Eliminado");
    },
    close() {
      this.form = {};
      this.total_dias_solicitadas = 0;
      this.dialog = false;
      this.permiso = {
        id_tipo_permiso: null,
        motivo: ""
      };
      this.permiso_detalles = [];
      this.count_id = 0;
      this.edit = true;
      this.$bus.$emit("closeDialogCrearPapeletaVacacion");
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async save() {
      let respuesta;

      let user = this.$storage.get("user");
      let id = user.id;
      let bandera_exito = false;
      let error_texto = "-1";
      try {
        let user = this.$storage.get("user");
        for (let i = 0; i < this.permiso_detalles.length; i++) {
          const elemento = this.permiso_detalles[i];
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_registra_cta_vacacion_cabecera(${this.getPersonaId()},${
              user.id
            })"){
                respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_registra_cta_vacacion_cabecera;
          let resps = respuesta.split("|");
          let correcto = resps[0];
          if (correcto == "1") {
            let id_permiso = parseInt(resps[1]);
            respuesta1 = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select control.fn_registra_cta_vacacion_detalle(${id_permiso},${
                user.id
              },'${elemento.fecha_desde}','${elemento.fecha_hasta}','${
                elemento.hora_desde
              }','${elemento.hora_hasta}',${parseInt(this.dato.rol)})"){
                respuesta
                }
              }
            `
            });
            let respuesta1 =
              respuesta1.runQuery.respuesta[0].fn_registra_cta_vacacion_detalle;
            let res = respuesta1.split("|");
            let correcto = res[0];
            if (correcto == "1") {
              bandera_exito = true;
            } else {
              bandera_exito = false;
              error_texto = res[1];
            }
          } else {
            this.$confirm(resps[1], () => {});
          }
        }

        if (bandera_exito == true) {
          if (this.dato.rol == 4) {
            let id_persona = parseInt(this.$route.params.id);
            this.$router.push("/permisos/usuario/" + id_persona);
          } else {
            this.close();
          }
        } else {
          this.$message.error(error_texto);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.footer-table {
  background-color: rgba(0, 92, 167, 0.699);
  color: rgba(255, 255, 255, 1);
  text-align: right;
}
.titulo {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/dialogs/CrearPermisoCargoVacacion.vue